import { Modal, Button, ModalBody, ModalFooter, Alert } from "react-bootstrap";
import { ErrorText } from "../../ui/ErrorReference";

const DeleteResultModal = ({
  show,
  handleClose,
  handleDelete,
  error,
  clearError,
  isDeleting,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Result</Modal.Title>
      </Modal.Header>
      <ModalBody>
        <p>Are you sure you want to delete this result?</p>
        {error && (
          <Alert variant='danger' className='mb-0' onClose={clearError} dismissible>
            <ErrorText error={error} />
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant='secondary' onClick={handleClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant='danger' onClick={handleDelete} disabled={isDeleting}>
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteResultModal;
